import { EMPTY_LIST, EMPTY_STRING } from '../../../../constants/common'
import { getListingUnitLabel } from '../../../RentalPortalListing'
import { LISTING_VIEWING_ROW_ACTIONS } from '../../../RentalPortalViewing'

import { APPLICANT_VIEWINGS_STATE } from './RentalPortalApplicantProfileViewings.constants'

export function getApplicantViewingsState({ hasError, isInitiated, viewings }) {
  if (hasError) {
    return APPLICANT_VIEWINGS_STATE.error
  }

  if (!isInitiated) {
    return APPLICANT_VIEWINGS_STATE.loading
  }

  return viewings?.length > 0
    ? APPLICANT_VIEWINGS_STATE.table
    : APPLICANT_VIEWINGS_STATE.empty
}

export function getApplicantViewingListingLabel({ item, t }) {
  return getListingUnitLabel({ listing: item, t }) ?? EMPTY_STRING
}

export function getApplicantViewingItemActions(viewing) {
  return viewing?.permissions?.can_view
    ? LISTING_VIEWING_ROW_ACTIONS
    : EMPTY_LIST
}

export function getIsApplicantViewingsEmpty(state) {
  return state === APPLICANT_VIEWINGS_STATE.empty
}

export function getIsApplicantViewingsError(state) {
  return state === APPLICANT_VIEWINGS_STATE.error
}
